// WarehouseQuoteDetailForm.tsx
import React, { useEffect } from 'react';
import LazyLoading from '../../../../../../../components/LazyLoading';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../../components/SelectTwo';
import { WarehouseQuoteDetailDataForm } from '../../../../../../../app/models/WareHouseQuoteDetail';
import { Service } from '../../../../../../../app/models/Service';
import { Product } from '../../../../../../../app/models/Product';
import { Currency } from '../../../../../../../app/models/Currency';
import { Unit } from '../../../../../../../app/models/Unit';
import { Depot } from '../../../../../../../app/models/Depot';
import useHandleErrorFields from '../../../../../../../hooks/useHandleErrorFields';
import { RatePeriodEnum } from '../../../../../../../app/shared/enums';

const RATE_PERIOD_OPTIONS = [
    { value: RatePeriodEnum.DIA, label: 'Día' },
    { value: RatePeriodEnum.SEMANA, label: 'Semana' },
    { value: RatePeriodEnum.MES, label: 'Mes' },
    { value: RatePeriodEnum.AÑO, label: 'Año' },
];

interface Props {
  warehouseQuoteDetailForm: WarehouseQuoteDetailDataForm;
  setWarehouseQuoteDetailForm: (form: WarehouseQuoteDetailDataForm) => void;
  services: Service[];
  products: Product[];
  currencies: Currency[];
  quantityUnits: Unit[];
  units: Unit[];
  depots: Depot[];
  disableUpdate?: boolean;
  disableStorage?: boolean;
  disableRate?: boolean;
  loadingStorageInfo?: boolean;
  errorFields?: any;
  isWarehouseForm?: boolean;
}

const WarehouseQuoteDetailForm: React.FC<Props> = ({
  warehouseQuoteDetailForm,
  setWarehouseQuoteDetailForm,
  quantityUnits,
  services,
  products,
  currencies,
  units,
  depots,
  disableUpdate = false,
  disableStorage = false,
  disableRate = false,
  loadingStorageInfo,
  errorFields,
  isWarehouseForm = false,
}) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();


    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setWarehouseQuoteDetailForm({ ...warehouseQuoteDetailForm, [name]: value });
  };

  const handleChangeSelectTwo = (field: string, value: number | string) => {
    setWarehouseQuoteDetailForm({ ...warehouseQuoteDetailForm, [field]: value });
  };
    if (!warehouseQuoteDetailForm) return null;
  return (
    <>
      {/* Servicio adicional */}
    {/* Servicio adicional */}
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Servicio</label>
      <div className="col-md-9">
        <SelectTwo
          name="service_id"
          id="service_id"
          inputValue={warehouseQuoteDetailForm.service_id}
          options={SelectTwoMapperOptions(services, 'id', ['name'])}
          onChange={v => handleChangeSelectTwo('service_id', v.value)}
          placeholder="Seleccione un servicio"
          disabled={disableUpdate}
          onFocus={() => onFocusRemove('service_id')}

        />
        <div className="invalid-feedback" style={{ display: 'flex' }}>
          {fieldErrorMessage('service_id')}
        </div>
      </div>
    </div>

    {/* Producto */}
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Producto</label>
      <div className="col-md-9">
        <SelectTwo
          name="product_id"
          id="product_id"
          inputValue={warehouseQuoteDetailForm.product_id}
          options={SelectTwoMapperOptions(products, 'id', ['name'])}
          onChange={v => handleChangeSelectTwo('product_id', v.value)}
          placeholder="Seleccione un producto"
          disabled={disableUpdate}
          onFocus={() => onFocusRemove('product_id')}

        />
        <div className="invalid-feedback" style={{ display: 'flex' }}>
          {fieldErrorMessage('product_id')}
        </div>
      </div>
    </div>

    {/* Fecha Cuota */}
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Fecha Cuota</label>
      <div className="col-md-9">
        <input
          type="date"
          className="form-control"
          name="quota_date"
          value={warehouseQuoteDetailForm.quota_date || ''}
          onChange={handleChange}
          disabled={disableUpdate}
          onFocus={() => onFocusRemove('quota_date')}

        />
        <div className="invalid-feedback" style={{ display: 'flex' }}>
          {fieldErrorMessage('quota_date')}
        </div>
      </div>
    </div>

    {/* Cantidad y unidad */}
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Cantidad</label>
      <div className="col-md-9">
        <div className="row g-1">
          <div className="col-6">
            <input
              type="number"
              name="quantity"
              className="form-control"
              value={warehouseQuoteDetailForm.quantity}
              onChange={handleChange}
              placeholder="Ingrese cantidad"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('quantity')}
              
            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('quantity')}
            </div>
          </div>
          <div className="col-6">
            <SelectTwo
              name="quantity_unit_id"
              id="quantity_unit_id"
              inputValue={warehouseQuoteDetailForm.quantity_unit_id}
              options={SelectTwoMapperOptions(quantityUnits)}
              onChange={v => handleChangeSelectTwo('quantity_unit_id', v.value)}
              placeholder="medida"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('quantity_unit_id')}
              
            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('quantity_unit_id')}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Almacén — solo formulario WAREHOUSE */}
    {isWarehouseForm && (
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Almacén</label>
      <div className="col-md-9">
        <SelectTwo
          name="depot_id"
          id="depot_id"
          inputValue={warehouseQuoteDetailForm.depot_id}
          options={SelectTwoMapperOptions(depots, 'id', ['name'])}
          onChange={v => handleChangeSelectTwo('depot_id', v.value)}
          placeholder="Seleccione un almacén"
          disabled={disableUpdate}
          onFocus={() => onFocusRemove('depot_id')}
        />
        <div className="invalid-feedback" style={{ display: 'flex' }}>
          {fieldErrorMessage('depot_id')}
        </div>
      </div>
    </div>
    )}

    {/* Precio Unitario + moneda + unidad */}
    <div className="mb-2 row">
      <label className="col-md-3 col-form-label">Precio Unitario Venta</label>
      <div className="col-md-9">
        <div className="row g-1">
          <div className="col-6">
            <input
              type="number"
              className="form-control"
              name="unit_price"
              value={warehouseQuoteDetailForm.unit_price ?? ''}
              onChange={handleChange}
              placeholder="Ej: 12000"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('unit_price')}

            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('unit_price')}
            </div>
          </div>
          <div className="col-3">
            <SelectTwo
              name="currency_id"
              id="currency_id"
              inputValue={warehouseQuoteDetailForm.currency_id}
              options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
              onChange={v => handleChangeSelectTwo('currency_id', v.value)}
              placeholder="Moneda"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('currency_id')}

            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('currency_id')}
            </div>
          </div>
          <div className="col-3">
            <SelectTwo
              name="rate_unit_id"
              id="rate_unit_id"
              inputValue={warehouseQuoteDetailForm.rate_unit_id}
              options={SelectTwoMapperOptions(quantityUnits)}
              onChange={v => handleChangeSelectTwo('rate_unit_id', v.value)}
              placeholder="Unidad"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('rate_unit_id')}
            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('rate_unit_id')}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Campos exclusivos del formulario WAREHOUSE */}
    {isWarehouseForm && (
      <>
        {/* Periodo de tarifa */}
        <div className="mb-2 row">
          <label className="col-md-3 col-form-label">Periodo tarifa</label>
          <div className="col-md-9">
            <SelectTwo
              name="rate_period"
              id="rate_period"
              inputValue={warehouseQuoteDetailForm.rate_period}
              options={RATE_PERIOD_OPTIONS}
              onChange={v => handleChangeSelectTwo('rate_period', v.value)}
              placeholder="Seleccione período"
              disabled={disableUpdate}
              onFocus={() => onFocusRemove('rate_period')}
            />
            <div className="invalid-feedback" style={{ display: 'flex' }}>
              {fieldErrorMessage('rate_period')}
            </div>
          </div>
        </div>

        {loadingStorageInfo ? (
          <LazyLoading height={100} />
        ) : (
          <>
            {/* Días libres */}
            <div className="mb-2 row">
              <label className="col-md-3 col-form-label">Días libres</label>
              <div className="col-md-9">
                <input
                  type="number"
                  className="form-control"
                  name="free_days"
                  value={warehouseQuoteDetailForm.free_days ?? ''}
                  onChange={handleChange}
                  placeholder="Cantidad de días sin cobro"
                  disabled={disableStorage}
                  onFocus={() => onFocusRemove('free_days')}
                />
                <div className="invalid-feedback" style={{ display: 'flex' }}>
                  {fieldErrorMessage('free_days')}
                </div>
              </div>
            </div>

            {/* Comentarios */}
            <div className="mb-2 row">
              <label className="col-md-3 col-form-label">Comentarios</label>
              <div className="col-md-9">
                <textarea
                  className="form-control"
                  name="comment"
                  value={warehouseQuoteDetailForm.comment || ''}
                  onChange={handleChange}
                  placeholder="Observaciones opcionales"
                  disabled={disableUpdate}
                  onFocus={() => onFocusRemove('comment')}
                />
                <div className="invalid-feedback" style={{ display: 'flex' }}>
                  {fieldErrorMessage('comment')}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    )}
    </>
  );
};

export default WarehouseQuoteDetailForm;
